import { render, staticRenderFns } from "./rightComponent.vue?vue&type=template&id=dca4901e&scoped=true&"
import script from "./rightComponent.vue?vue&type=script&lang=js&"
export * from "./rightComponent.vue?vue&type=script&lang=js&"
import style0 from "./rightComponent.vue?vue&type=style&index=0&id=dca4901e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca4901e",
  null
  
)

export default component.exports